export default __webpack_public_path__ + "static/media/preview-basic.ee45938c.gif";